<script>

  import SgsRenderInputDataFormWrapper from './SgsRenderInputDataFormWrapper.vue';
  import SgsRenderInputDataShowOrListWrapper from './SgsRenderInputDataShowOrListWrapper.vue';
  import utils from 'src/app/module/FormBuilderUtils.js';
  import moduleUtils from 'src/app/module/ModuleUtils';

  export default {
    props: [
      "attr", "fieldValue", "formIdentifier", "rules",
      "label", "showHint", "hintValue", "moduleType", "placeholder",
      "instance", "disableField"
    ],
    methods: {
      callBusinessRule: function(BusinessRuleId) {
        this.$emit('callBusinessRule', BusinessRuleId);
      }
    },
    components: {
      SgsRenderInputDataFormWrapper,
      SgsRenderInputDataShowOrListWrapper
    },
    computed: {
      updateFieldValue: {
        get: function() {
          return this.fieldValue;
        },
        set: function(newValue) {
          this.$emit('updateFieldValue', this.attr.columnName, newValue);
        }
      }
    }
  }
</script>
<template>
  <div>
    <SgsRenderInputDataFormWrapper
      v-if="moduleType === 'form'"
      :attr="attr"
      :formIdentifier="formIdentifier"
      :fieldValue="fieldValue"
      v-model="updateFieldValue"
      :moduleType="moduleType"
      :rules="rules"
      :showHint="showHint"
      :label="label"
      :hintValue="hintValue"
      :placeholder="placeholder"
      :instance="instance"
      @callBusinessRule="callBusinessRule"
      :disableField="disableField"
    />

    <SgsRenderInputDataShowOrListWrapper
      v-else
      :attr="attr"
      :formIdentifier="formIdentifier"
      :fieldValue="fieldValue"
      :label="label"
      :moduleType="moduleType"
    />

  </div>
</template>



// WEBPACK FOOTER //
// SgsRenderInputDataWrapper.vue?34903900